export const PORTAL_LAYOUT_ROUTE = "/portal";

// Root
export const RESUME_ROUTE = "/resumen";
export const TRANSACTIONS_ROUTE = "/transacciones";
export const USERS_ROUTE = "/usuarios";
export const SRPAGO_CARD_ROUTE = "/tarjeta-srpago";
export const BANK_ACCOUNTS_ROUTE = "/cuentas-bancarias";
export const OPERATORS_ROUTE = "/operadores";
export const INVOICES_ROUTE = "/invoices";
export const DISTRIBUTORS = "/distribuidores";

// Sales Point
export const SALES_POINT_ROUTE = "/punto-de-venta";
export const READER_ROUTE = "/lector";
export const CASH_PAYMENT_ROUTE = "/pago-en-efectivo";
export const SPEI_TRANSFER_ROUTE = "/transferencia-spei";

// E-Commerce
export const ECOMMERCE_ROUTE = "/e-commerce";
export const EXPRESS_CHARGE_ROUTE = "/cobro-express";
export const PAYMENT_BUTTON_ROUTE = "/boton-de-pago";
export const TRANSFER_BETWEEN_USERS_ROUTE = "/transferencia-entre-usuarios";

// Developers
export const DEVELOPERS_ROUTE = "/developers";
export const APPLICATIONS_ROUTE = "/aplicaciones";
